<template>
  <div>
    <el-row>
      <el-col>
        <Title
          title="Importar puntos"
          subtitle="Carga por archivo puntos geocodificados"/>
      </el-col>
      <el-col>
        <upload :maxSize="2"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Title from '../../components/base/Title.vue';
import Upload from '../../components/import/Upload.vue';

export default {
  name: 'ImportPoints',
  components: {
    Title,
    Upload,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
